import React from 'react';
import Card from '../../components/common/Card';

const TransferenciaForm = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Nueva Transferencia</h1>
      <Card>
        <p className="text-center text-gray-500 py-8">
          Formulario de Transferencia - En desarrollo
        </p>
      </Card>
    </div>
  );
};

export default TransferenciaForm;